import { apiGet, apiPost } from '@/utils/request';

export interface KuaishouAccountItem {
  id: number;
  external_id: string;
  name: string;
  alias: string;
  kuaishou_ad: 0 | 1;
  advertiser_id: string;
}

export interface KuaishouAccountsParams extends Record<string, unknown> {
  name?: string;
  alias?: string;
  status?: 0 | 1;
  page?: number;
  page_size?: number;
}

export interface KuaishouAccountsData {
  list: KuaishouAccountItem[];
  total: number;
  page: number;
  page_size: number;
}

export interface KuaishouChangeConfigParams {
  id: number;
  kuaishou_ad?: 0 | 1;
  advertiser_id?: string;
  alias?: string;
}

export interface KuaishouChangeConfigResult {
  id: number;
  kuaishou_ad: 0 | 1;
  advertiser_id: string;
  alias: string;
}

export interface KuaishouReportLogItem {
  id: number;
  user_id: number;
  account_id: string;
  progress: number;
  progress_text: string;
  status: 0 | 1 | 2;
  status_text: string;
  progress_status_text: string;
  post_data: Record<string, unknown>;
  response: Record<string, unknown>;
  created_at: string;
}

export interface KuaishouReportLogsParams extends Record<string, unknown> {
  user_id?: string | number;
  status?: string | number;
  start_time?: string;
  end_time?: string;
  page?: number;
  page_size?: number;
}

export interface KuaishouReportLogsData {
  list: KuaishouReportLogItem[];
  total: number;
  page: number;
  page_size: number;
}

export const kuaishouAdApi = {
  getAccounts: (params?: KuaishouAccountsParams) =>
    apiGet<KuaishouAccountsData>('/kuaishou-ad/accounts', params),

  changeConfig: (params: KuaishouChangeConfigParams) =>
    apiPost<KuaishouChangeConfigResult>('/kuaishou-ad/change-config', params),

  getReportLogs: (params: KuaishouReportLogsParams) =>
    apiGet<KuaishouReportLogsData>('/kuaishou-ad/report-logs', params),
};
